import { useAppSelector } from "../../store/hooks";
import { selectActiveModule } from "../../store/slices/moduleSlice";
import { MODULE_IDS } from "../../config/modules";
import InsuranceDashboard from "./InsuranceDashboard";
import EventsMediaDashboard from "./EventsMediaDashboard";
import TravelToursDashboard from "./TravelToursDashboard";
import SafetyServicesDashboard from "./SafetyServicesDashboard";

/**
 * Module-aware Dashboard Component
 * Renders different dashboard content based on the active module
 */
export default function ModuleDashboard() {
  const activeModule = useAppSelector(selectActiveModule);

  if (!activeModule) {
    return <EventsMediaDashboard />; // Default fallback
  }

  // Render module-specific dashboard based on active module
  switch (activeModule.id) {
    case MODULE_IDS.INSURANCE:
      return <InsuranceDashboard />;
    
    case MODULE_IDS.EVENTS_MEDIA:
      return <EventsMediaDashboard />;
    
    case MODULE_IDS.TRAVEL_TOURS:
      return <TravelToursDashboard />;
    
    case MODULE_IDS.SAFETY_SERVICES:
      return <SafetyServicesDashboard />;
    
    default:
      return <EventsMediaDashboard />;
  }
}

